import React from "react";
import AggregatedSummaryList from "components/AggregatedSummaryList/AggregatedSummaryList";
import { TRANSCRIBER_FAX_PROGRAM_TYPE_LIST_COLUMNS } from "lookup/TranscriberProgramConstants.jsx";
import { showNotification } from "services/NotificationService";

const transcriberProgramTypeListConfig = {
  id: "transcriber-program-type-list",
  mode: "api-driven",
  cache: { enabled: false },
  header: {
    totalLabel: "Total Faxes",
    title: "Transcriber Fax Programs",
    totalCountColumn: "faxCount",
    refreshTestId: "transcriber-program-type-refresh",
  },
  fetch: {
    url: "/transcriber/program-type-list",
    mapResponse: (response) => ({
      rows: response?.data?.programs || [],
    }),
  },
  notifications: {
    loadError: {
      title: "Unable to load Transcriber Fax Programs!",
      message: "SOMETHING WENT WRONG",
    },
  },
  table: {
    getColumns: () => TRANSCRIBER_FAX_PROGRAM_TYPE_LIST_COLUMNS,
    showPagination: false,
    pageSize: 25,
    rowClassName: "clickable-row",
  },
  rowClick: {
    onRowClick: (row, navigate) => {
      if (!row.original.faxCount) {
        showNotification({
          title: "No Faxes Available",
          message: `Fax program "${row.original.faxProgram}" has 0 faxes.`,
          position: "tr",
          type: "warning",
        });
        return;
      }

      navigate(
        `/transcription/list?programCode=${encodeURIComponent(row.original.faxProgramCode)}`
      );
    },
  },
};

const TranscriberProgramTypeList = () => (
  <AggregatedSummaryList config={transcriberProgramTypeListConfig} />
);

export default TranscriberProgramTypeList;
